import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-form";
const gray = objectWithClassName({
  className: `${classNamePrefix}-gray`
});
export {
  gray
};
//# sourceMappingURL=form.js.map
